import { sendRequest } from "~/api/clients/axios";
import { ApiGetResponse } from "~/types/common/auth.types";
import { AxiosHttpError } from "~/types/common/error.types";
import { UpdateUserInput, User } from "~/types/data/User.types";

export default async function updateUser(
  input: UpdateUserInput
): Promise<ApiGetResponse<User>> {
  try {
    const res = await sendRequest<UpdateUserInput, User>(
      "post",
      "/auth/update-user",
      input
    );
    return { success: true, data: res.data };
  } catch (err) {
    const axiosError = err as AxiosHttpError;
    if (axiosError.response?.data) {
      const { message } = axiosError.response.data;
      return {
        success: false,
        errorMessage: typeof message === "string" ? message : message[0],
      };
    }
  }
  return {
    success: false,
    errorMessage: "Unkown Error",
  };
}
